import { LocalstorageService } from "./../services/localstorage.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";
import { ApiBasic } from "../services/api-basic";
import { GlobalServiceService } from "../services/global-service.service";
import { Subscription } from "rxjs";

@Injectable()
export class FeedbackProvider {
  private token = "";
  subscription: Subscription;

  private httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };
  appBase;
  constructor(
    private http: HttpClient,
    private api: ApiBasic,
    private _localstorage: LocalstorageService,
    private _global: GlobalServiceService
  ) {
    // this._global.base_url = this.api.base_url;
    this.token = _global.token;
    this.subscription = this._localstorage.getToken().subscribe((message) => {
      this.token = _global.token;
    });
  }

  public setFeedBack(data: any) {
    return this.http.post(`${this._global.base_url}/feedback/`, data, {});
  }

  public getFeedBackType() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        // "Authorization": `Bearer ${this.token}`,
      })
    };

    return this.http.get(this._global.base_url + "/feedbacktypes",httpOptions);
  }
}
